module.exports = __webpack_public_path__ + "img/blueuparrow.23deb62a.svg";